var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToday(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 90C69.8528 90 90 69.8528 90 45C90 20.1472 69.8528 0 45 0C20.1472 0 0 20.1472 0 45C0 69.8528 20.1472 90 45 90Z",
    fill: "#ED2F54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7192 28.6445H74.2808V72.9702H15.7192V28.6445Z",
    fill: "#F5F5F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 28.6445H74.2799V72.9695H45V28.6445Z",
    fill: "#E0E3EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7192 66.1865H74.2808V75.0804H15.7192V66.1865Z",
    fill: "#E0E3EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 66.1865H74.2799V75.0793H45V66.1865Z",
    fill: "#C3CADD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7606 16.457H74.2395V30.9755H15.7606V16.457Z",
    fill: "#FED940"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45 16.458H74.2394V30.9758H45V16.458Z",
    fill: "#FDBF2D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3723 20.385V12.53C55.3723 10.6135 56.9261 9.05957 58.8428 9.05957C60.7595 9.05957 62.3132 10.6133 62.3132 12.53V20.3852C62.3132 22.3019 60.7595 23.8556 58.8428 23.8556C56.9261 23.8554 55.3723 22.3017 55.3723 20.385Z",
    fill: "#EF7A06"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6868 20.385V12.53C27.6868 10.6135 29.2405 9.05957 31.1572 9.05957C33.0739 9.05957 34.6277 10.6133 34.6277 12.53V20.3852C34.6277 22.3019 33.0739 23.8556 31.1572 23.8556C29.2405 23.8554 27.6868 22.3017 27.6868 20.385Z",
    fill: "#FD9827"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7161 44.1292C58.7161 53.2147 45.0879 58.7663 45.0879 58.7663C45.0879 58.7663 31.4597 53.2147 31.4597 44.1292C31.4597 39.9469 34.9135 36.5576 39.1737 36.5576C41.5486 36.5576 43.6726 37.6114 45.0879 39.2677C46.5032 37.6114 48.6272 36.5576 51.0021 36.5576C55.2622 36.5576 58.7161 39.9469 58.7161 44.1292Z",
    fill: "#F79CAF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2599 52.8898C50.2846 56.6482 45.0879 58.7657 45.0879 58.7657C45.0879 58.7657 31.4597 53.214 31.4597 44.1285C31.4597 40.5892 33.9331 37.6173 37.2764 36.7881C36.6421 37.8879 36.2795 39.1597 36.2795 40.5136C36.2795 49.5991 49.9078 55.1507 49.9078 55.1507C49.9078 55.1507 51.8456 54.3609 54.2599 52.8898Z",
    fill: "#E3889B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7781 37.2401L45.0878 37.4845L45.3976 37.2401C46.974 35.9961 48.9416 35.3047 51.0019 35.3047C55.9529 35.3047 59.9686 39.2706 59.9688 44.1285C59.9688 48.9609 56.601 52.8353 53.03 55.5757C49.4769 58.3022 45.8443 59.8106 45.5605 59.9262L45.5605 59.9263C45.2575 60.0497 44.9181 60.0496 44.6153 59.9263L44.6153 59.9262C44.3314 59.8106 40.6989 58.3022 37.1458 55.5757C33.5747 52.8353 30.207 48.9609 30.207 44.1285C30.207 39.2706 34.2227 35.3047 39.1737 35.3047C41.2341 35.3047 43.2017 35.9961 44.7781 37.2401ZM44.8763 57.3034L45.0865 57.4005L45.2965 57.3031C46.6052 56.6961 49.6188 55.1802 52.3129 52.9529C54.9884 50.7409 57.4633 47.7321 57.4633 44.1285C57.4633 40.6327 54.5536 37.8101 51.0019 37.8101C49.084 37.8101 47.2745 38.6366 46.0402 40.0816C45.5404 40.6668 44.6348 40.6667 44.1351 40.0816C42.901 38.6367 41.0915 37.8102 39.1736 37.8102C35.6219 37.8102 32.7123 40.6327 32.7123 44.1286C32.7123 47.1599 34.528 49.8763 36.9015 52.0939C39.2848 54.3206 42.3028 56.1141 44.8763 57.3034Z",
    fill: "black",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToday);
export default __webpack_public_path__ + "static/media/today.1dd3b0cf03b58a2c79b9e4251fd4fbb6.svg";
export { ForwardRef as ReactComponent };